<template>
<div>
  <el-row>
    <el-col class="content" :span="24">
      <el-menu
      unique-opened="true"
      :default-active="firstActive"
      class="el-menu-vertical"
      active-background-color="#354ECE"
      text-color="#8FA1B7"
      active-text-color="#354ECE"
      :default-openeds="defaultOpeneds">
        <el-submenu :index="data.index.toString()" v-for="(data,i) in this.datalist" :key="data.index">
          <template slot="title">
            <img :src="data.img" alt="">
            <span>{{data.name}}</span>
          </template>
          <el-submenu :index="item.entityId.toString()" v-for="item in data.list" :key="item.entityId">
            <template slot="title"><span>{{item.name}}</span></template>
            <div v-for="child in item.apiMenu" :key="child.entityId">
              <router-link :to="pathPre + child.url" v-if="typeof(child.url)!='undefined'">
                <el-menu-item :index="!child.entityId?'0':child.entityId.toString()">
                  <el-tooltip class="item" effect="light" :content="child.name" placement="right" :open-delay=800>
                    <span class="ellipsis">{{child.name}}</span>
                  </el-tooltip>
                </el-menu-item>
              </router-link>
              <el-menu-item :index="!child.entityId?'0':child.entityId.toString()" @click="handleFilterData(child.order)" v-else>
                <span class="ellipsis">{{child.name}}</span>
              </el-menu-item>
            </div>
          </el-submenu>
          <el-divider v-if="i<datalist.length-1"></el-divider>
        </el-submenu>
      </el-menu>
    </el-col>
  </el-row>
</div>
</template>

<script>
import constant from '../utils/constant'
import $ from 'jquery'

export default {
  props: ['datalist'],
  data () {
    return {
      pathPre: constant.pathPre,
      firstActive: '',
      defaultOpeneds: []
    }
  },
  created: function () {
    let hasFirstActive = false
    this.defaultOpeneds = []
    console.log(57, this.datalist)
    this.datalist.forEach(item => {
      item.list.forEach(citem => {
        citem.apiMenu && citem.apiMenu.forEach(titem => {
          this.firstActive = window.location.href.split('/')[window.location.href.split('/').length - 1]
          if(titem.entityId == this.firstActive) {
            this.defaultOpeneds = [item.index.toString(), citem.entityId.toString(), titem.entityId.toString()]
          }
        })
      })
    })
    // for (let i in this.datalist) {
    //   this.defaultOpeneds.push(this.datalist[i].index.toString())
    //   for (let j in this.datalist[i].list) {
    //     this.defaultOpeneds.push(this.datalist[i].list[j].entityId.toString())
    //     for (let k in this.datalist[i].list[j].apiMenu) {
    //       if (!hasFirstActive) {
    //         hasFirstActive = !hasFirstActive
    //         this.firstActive = this.datalist[i].list[j].apiMenu[k].entityId.toString()
    //       }
    //       this.defaultOpeneds.push(this.datalist[i].list[j].apiMenu[k].entityId.toString())
    //     }
    //   }
    // }
  },
  methods: {
    handleFilterData (order) {
      this.$emit('order', order)
    }
  },
  mounted: function () {
    let submenuTitle = $('.el-menu >>> .el-submenu .el-submenu__title')
    $.each(submenuTitle, function (key, item) {
      let hasFirstMenu = $(item).children().is('span')
      if (!hasFirstMenu) {
        $(item).remove()
      } else {
        let hasFirstMenuTxt = $(item).find('span').text()
        if (hasFirstMenuTxt === '') {
          $(item).remove()
        }
      }
    })
  }
}
</script>

<style scoped>
.content{
    padding: 30px 0 30px 0;
    height: 100%;
}
  .content,.el-menu /deep/ .el-submenu .el-submenu__title,.el-menu .el-submenu .el-menu-item-group ul li.el-menu-item{
      background: #fff;
  }
  .el-row,.el-menu{
    height: 100%;
  }
  .el-menu /deep/ .el-menu>.el-submenu>.el-submenu__title{
    padding-top: 8px !important;
    height: 48px;
    line-height: 40px;
    text-align: left;
  }
  .el-menu /deep/ .el-menu>.el-submenu>.el-submenu__title>i{
    padding-top: 8px !important;
    line-height: 20px;
  }
  .el-menu /deep/ .el-submenu .el-submenu__title{
    padding-left: 45px !important;
  }
  .el-menu /deep/ .el-submenu .el-submenu__title,
  .el-menu /deep/ .el-submenu .el-menu .el-submenu .el-menu li.el-menu-item,
  .el-menu /deep/ .el-submenu .el-menu .el-submenu .el-menu a>li.el-menu-item{
      height: 40px;
      line-height: 40px;
      text-align: left;
  }
  .el-menu /deep/ .content>.el-menu>.el-submenu>.el-submenu__title{
    text-align: left;
    padding-left: 45px !important;
  }
  .el-menu /deep/ .el-submenu>.el-submenu__title>span{
    padding: 0 0 8px 0;
    width: 100%;
    height: 25px;
    text-align: left;
    font: Bold 18px/21px Microsoft YaHei;
    letter-spacing: 0;
    color: rgba(0,0,0,.85);
  }
  .el-menu /deep/ .el-submenu>.el-submenu__title>img{
      padding: 0 8px 0 0;
  }
  .el-menu /deep/ .el-submenu>.el-menu>.el-submenu>.el-submenu__title{
    padding-left: 70px !important;
  }
  .el-menu /deep/ .el-submenu>.el-menu>.el-submenu>.el-submenu__title>span{
    text-align: left;
    font: 14px/19px Microsoft YaHei;
    letter-spacing: 0;
    color: rgba(0,0,0,.85);
  }
  .el-menu /deep/ .el-submenu .el-menu .el-submenu .el-menu li.el-menu-item,
  .el-menu /deep/ .el-submenu>.el-menu>.el-submenu>.el-menu a>li{
    padding-left: 80px !important;
    text-align: left;
  }
  .el-menu /deep/ .el-submenu .el-menu-item-group ul li.el-menu-item
  {
      line-height: 20px;
      height: 36px;
      padding: 10px 0;
  }

  .el-divider--horizontal {
    width: 100px;
    margin: 16px 0 16px 70px;
  }

/* 单行超出省略 */
.ellipsis{
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/PgNavMenu.vue